import { Box } from '@taraai/design-system';
import React, { ReactNode } from 'react';

export function StopPropagation({ children }: { children: ReactNode }): JSX.Element {
  return <Box onClick={(event) => event.stopPropagation()}>{children}</Box>;
}
